(function(): void {
    const metaFastify = document.querySelector('meta[name="api-fastify-base"]');
    const metaFastifyBase = metaFastify ? metaFastify.getAttribute('content') : '';
    const fastifyBase = window.API_FASTIFY_BASE || metaFastifyBase || '';

    function normalizeBase(url: string): string {
        if (!url) {
            return '';
        }
        return url.endsWith('/') ? url.slice(0, -1) : url;
    }

    function apiUrl(path: string): string {
        if (!path) {
            return path;
        }
        if (path.startsWith('http://') || path.startsWith('https://')) {
            return path;
        }
        const baseUrl = normalizeBase(fastifyBase);
        if (!baseUrl) {
            return path;
        }
        if (path.startsWith('/')) {
            return baseUrl + path;
        }
        return baseUrl + '/' + path;
    }

    // Both functions now use Fastify base for consistency
    window.API_BASE = fastifyBase;
    window.API_FASTIFY_BASE = fastifyBase;
    window.apiUrl = apiUrl;
    window.apiUrlFastify = apiUrl;
})();
